function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8648"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8307",
    style: {
      fill: "#fff"
    },
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8647"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41562",
    d: "m-1455.748 54.2 8.812-.01a2.328 2.328 0 0 1 1.33.374 2.632 2.632 0 0 1 .167 1.122v50.329a2.858 2.858 0 0 1-3.154 3.051q-12.078.015-24.155 0h-11.64a1.854 1.854 0 0 1-1.4-.349 2.754 2.754 0 0 1-.3-1.682V59.824c0-.941-.011-1.883 0-2.825a2.659 2.659 0 0 1 2.832-2.81c2.914 0 5.828 0 8.743.006.18.239.04.476-.018.7-.2.76-.437 1.507-.629 2.268-.135.309-.137.686-.464.9a4.4 4.4 0 0 1-1.455.1c-1.356.011-2.712 0-4.068 0a1.048 1.048 0 0 0-1.08.5 1.576 1.576 0 0 0-.128.854v45.164c0 .224.016.447.036.671a.964.964 0 0 0 .948.951 6.59 6.59 0 0 0 .873.039h30.558c1.772 0 1.911-.145 1.911-1.914v-45.03c-.024-.971-.146-1.108-1.106-1.239-1.632.03-3.264.009-4.9.011a1.845 1.845 0 0 1-.661-.088.511.511 0 0 1-.285-.351q-.458-1.473-.85-2.965a.545.545 0 0 1 .083-.566z",
    transform: "translate(1497.095 -47.243)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41563",
    d: "M-1484.385 110.426a9 9 0 0 0 2.135.132c11.707 0 23.414-.019 35.12.024a2.932 2.932 0 0 0 2.908-2.886q-.079-25.2-.024-50.393a2.19 2.19 0 0 1 .042-1.032 2.381 2.381 0 0 1 1.3 1.832 5.9 5.9 0 0 1 .085.934q.006 24.9 0 49.8a3.128 3.128 0 0 1-.571 2.024 2.527 2.527 0 0 1-1.935 1.057c-.179.008-.358.022-.537.022q-17.9 0-35.8.008a2.869 2.869 0 0 1-2.645-1.274 1.044 1.044 0 0 1-.078-.248z",
    transform: "translate(1495.692 -48.947)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41564",
    d: "m-1426.213 30.016.778-2.932c.082-.3.158-.6.246-.9a1.825 1.825 0 0 1 2.091-1.556c.872 0 1.747-.044 2.615.014.646.043.9-.139 1.029-.812a3.174 3.174 0 0 1 2.583-2.6 3.3 3.3 0 0 1 3.427 1.145 3.54 3.54 0 0 1-.182 3.742 3.6 3.6 0 0 1-4.322 1.29 3.9 3.9 0 0 0 2.05.441 3.115 3.115 0 0 0 2.965-2.384c.08-.3.071-.631.35-.846l3.21.023c.054.039.126.066.151.13a11.394 11.394 0 0 1 .982 3.949 1.859 1.859 0 0 1-1.585 1.749 3.785 3.785 0 0 1-.737.049h-14.658a2.57 2.57 0 0 1-.669-.047c-.225-.061-.45-.137-.324-.455z",
    transform: "translate(1448.017 -20.127)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41565",
    d: "m-1408.033 43.634.978 3.783c.31.237.251.545.161.855a1.967 1.967 0 0 1-2 1.477c-2.036.022-4.073.007-6.11.007h-10.877a2.027 2.027 0 0 1-1.731-.708.845.845 0 0 1-.258-.854 1.63 1.63 0 0 1 1.162-.2q7.738-.01 15.476 0h.74c1.427-.034 2.044-.79 1.757-2.2-.225-1.1-.587-2.164-.886-3.244a2.771 2.771 0 0 1-.164-.787c0-.2-.049-.483.313-.457a1.773 1.773 0 0 1 1.131 1.386 3.48 3.48 0 0 0 .308.942z",
    transform: "translate(1449.38 -36.674)",
    style: {
      fill: "#007863"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41566",
    d: "M-1410.371 40.423c-.251.159-.171.369-.109.593.347 1.246.7 2.489 1.021 3.742.424 1.663-.28 2.559-1.981 2.559h-17.275c-.4-.241-.368-.509-.049-.795a2.112 2.112 0 0 1 .289-.845c.045.315.282.292.509.292 5.2 0 10.4.007 15.594-.006a1.771 1.771 0 0 0 1.627-2.371c-.273-1.1-.591-2.195-.89-3.292a1.686 1.686 0 0 1 1.264.123z",
    transform: "translate(1450.279 -35.79)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41567",
    d: "M-1377.345 30.3a3.924 3.924 0 0 1-1.579 2.891 3.647 3.647 0 0 1-4.355-.451 5.219 5.219 0 0 0 1.952.442 3.447 3.447 0 0 0 3.2-4.641c-.057-.152-.247-.292-.079-.484a3.435 3.435 0 0 1 .861 2.243z",
    transform: "translate(1412.779 -25.806)",
    style: {
      fill: "#007863"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41568",
    d: "M-1459.149 75.136a.91.91 0 0 0 .049.795 1.6 1.6 0 0 0 1.518 1.347c.6.035 1.209.026 1.813.026h15.39c1.436 0 2.252-.88 2.039-2.157l5.611-.007a1.57 1.57 0 0 1 .218 1.158q.009 8.478 0 16.956v27.116c0 1.872-.22 2.094-2.084 2.094h-30.077c-1.38 0-1.38 0-1.38-1.4V76.453a1.716 1.716 0 0 1 .061-.8.807.807 0 0 1 .889-.541z",
    transform: "translate(1480.664 -64.402)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41569",
    d: "M-1466.287 75.721v45.691c0 .894 0 .894.918.894h30.954c1.174 0 1.381-.2 1.381-1.346V75.202c1.065-.06 1.347.193 1.347 1.216v46.03c0 .982-.285 1.288-1.28 1.288q-16.084.008-32.168 0c-.98 0-1.287-.309-1.287-1.213q0-22.982.008-45.963c.002-.281-.091-.586.127-.839z",
    transform: "translate(1480.97 -64.464)",
    style: {
      fill: "#e5e6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41570",
    d: "M-1377.334 30.671a1.664 1.664 0 0 1 .951 1.809 1.609 1.609 0 0 1-1.221 1.352c-.763.231-1.449-.137-1.993-1.054a1.434 1.434 0 0 1 .338-1.848 1.478 1.478 0 0 1 1.925-.259z",
    transform: "translate(1409.922 -27.752)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41571",
    d: "M-1379.141 28.654a1.713 1.713 0 0 0-2.263 2.106c-.059.091-.134.115-.211.031a1.749 1.749 0 0 1 .327-2.486 1.443 1.443 0 0 1 2.147.349z",
    transform: "translate(1411.729 -25.735)",
    style: {
      fill: "#007863"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41572",
    d: "M-1340.613 270.124c0 .7.01 1.391 0 2.086a1.124 1.124 0 0 1-1.236 1.265q-2.12.023-4.239 0a1.108 1.108 0 0 1-1.219-1.218q-.028-2.119 0-4.239a1.127 1.127 0 0 1 1.273-1.238q2.086-.027 4.172 0a1.127 1.127 0 0 1 1.248 1.259c.014.694.001 1.39.001 2.085z",
    transform: "translate(1383.293 -221.567)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41573",
    d: "M-1347.3 127.172c0-.7-.013-1.391 0-2.086a1.125 1.125 0 0 1 1.256-1.251q2.086-.021 4.172 0c.859.008 1.262.426 1.268 1.3q.014 2.052 0 4.105a1.136 1.136 0 0 1-1.285 1.287q-2.052.018-4.1 0c-.9-.007-1.3-.422-1.307-1.339-.004-.669-.004-1.343-.004-2.016z",
    transform: "translate(1383.273 -104.345)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41574",
    d: "M-1343.963 195.473c.718 0 1.435-.011 2.153 0a1.058 1.058 0 0 1 1.185 1.154q.027 2.152 0 4.306a1.051 1.051 0 0 1-1.159 1.178q-2.186.023-4.373 0a1.037 1.037 0 0 1-1.153-1.111q-.042-2.186 0-4.373a1.065 1.065 0 0 1 1.2-1.149c.71-.015 1.43-.005 2.147-.005z",
    transform: "translate(1383.299 -163.099)",
    style: {
      fill: "#00c9a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41575",
    d: "M-1460.41 95.369V82.116c0-.954.068-1.02 1.046-1.02 1.054 0 2.108.013 3.162-.007.4-.007.7.124.716.521.013.413-.328.554-.7.558-.83.009-1.661.038-2.489-.008-.556-.031-.671.182-.669.694q.023 8.678.01 17.357v8.611a2.193 2.193 0 0 1-.052.6.432.432 0 0 1-.39.327.57.57 0 0 1-.539-.333 1.538 1.538 0 0 1-.093-.791q-.003-6.625-.002-13.256z",
    transform: "translate(1476.035 -69.299)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41576",
    d: "M-1430.344 200.751c-.018-.013-.042-.023-.053-.04-1.175-1.807-1.193-1.818-.1-3.655 1.141-1.921.472-1.534 2.721-1.574.493-.009.986.01 1.479.017a3.664 3.664 0 0 1 1.162 1.76.884.884 0 0 1-.143.77c-.42.793-.892 1.555-1.351 2.325a.987.987 0 0 1-.8.555 25.9 25.9 0 0 1-2.554 0 .619.619 0 0 1-.361-.158z",
    transform: "translate(1452.158 -163.102)",
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41577",
    d: "M-1429.05 129a3.322 3.322 0 0 1 .553-4.213 3.3 3.3 0 0 1 4.19-.254 4.426 4.426 0 0 1 .137 2.24 3.617 3.617 0 0 1-4.086 2.574 3.958 3.958 0 0 1-.794-.347z",
    transform: "translate(1450.73 -104.408)",
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41578",
    d: "M-1425.992 200.706c.915 0 1.83-.011 2.744 0a.773.773 0 0 0 .768-.416q.708-1.247 1.444-2.478a.761.761 0 0 0-.029-.871c-.3-.493-.589-.994-.883-1.492a.707.707 0 0 1 .87.437c.464.815.928 1.63 1.407 2.436a.778.778 0 0 1-.008.876 87.879 87.879 0 0 0-1.405 2.437.9.9 0 0 1-.873.5h-2.684c-.952.002-1.028-.835-1.351-1.429z",
    transform: "translate(1447.806 -163.057)",
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41579",
    d: "M-1427.621 275.236q1.245-2.232 2.493-4.461c.049-.087.159-.14.24-.209.292.074.417.315.554.548.554.945 1.084 1.9 1.614 2.862.5.907.211 1.44-.8 1.461-1.14.024-2.28.012-3.421 0a.778.778 0 0 1-.68-.201z",
    transform: "translate(1449.142 -224.683)",
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41580",
    d: "M-1426.737 131.882a6.782 6.782 0 0 0 2.2.169 3.426 3.426 0 0 0 2.511-4.039c-.059-.195-.244-.416.034-.6a3.207 3.207 0 0 1 1.37 3.327 3.377 3.377 0 0 1-2.8 2.722 3.318 3.318 0 0 1-3.315-1.579z",
    transform: "translate(1448.417 -107.289)",
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41581",
    d: "M-1429.484 274.677c1.43.005 2.86.022 4.289.012.67 0 .892-.372.565-.966-.688-1.249-1.412-2.479-2.121-3.716.4-.286.617-.022.793.286.906 1.59 1.812 3.179 2.7 4.779.321.579.09.959-.569.964q-2.483.017-4.967 0c-.362 0-.811.151-1.025-.286s.074-.761.335-1.073z",
    transform: "translate(1451.005 -224.124)",
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41582",
    d: "M-1459.722 247.619c-.274-.1-.595-.153-.587-.536a.494.494 0 0 1 .506-.52.493.493 0 0 1 .542.483c.032.315-.165.49-.461.573z",
    transform: "translate(1475.948 -204.999)",
    style: {
      fill: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41583",
    d: "M-1339.548 279.53a.839.839 0 0 1-.525-.225c-.4-.4-.8-.787-1.186-1.188a.6.6 0 0 1-.019-.944.622.622 0 0 1 .9.033c.272.224.486.726.785.653.339-.083.6-.5.889-.772.259-.246.5-.517.771-.747a.585.585 0 0 1 .847.023.562.562 0 0 1 .041.842 79.629 79.629 0 0 1-2.131 2.14 1.237 1.237 0 0 1-.372.185z",
    transform: "translate(1378.516 -229.278)",
    style: {
      fill: "#f0f1f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41584",
    d: "M-1336.892 133.855a.664.664 0 0 1-.235.535c-.635.634-1.267 1.271-1.9 1.9a.7.7 0 0 1-1.116 0 75.71 75.71 0 0 1-1.094-1.1.608.608 0 0 1-.047-.948c.313-.308.647-.214.962.042.821.666.822.663 1.587-.1.27-.269.537-.542.819-.8a.6.6 0 0 1 .693-.081.553.553 0 0 1 .331.552z",
    transform: "translate(1378.513 -112.07)",
    style: {
      fill: "#f0f1f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41585",
    d: "M-1336.872 205.247a.753.753 0 0 1-.28.586q-.923.929-1.852 1.854a.685.685 0 0 1-1.106.008c-.359-.369-.727-.73-1.092-1.094a.617.617 0 0 1-.081-.947c.3-.325.626-.254.949.011.838.687.84.682 1.632-.108.269-.269.535-.542.818-.8a.556.556 0 0 1 .686-.06.572.572 0 0 1 .326.55z",
    transform: "translate(1378.493 -170.597)",
    style: {
      fill: "#f0f1f0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.47af1871c0e1cc9d2c76f90a4840431c.svg";
export { ForwardRef as ReactComponent };